export const numberWithCommas = (x: string | number | undefined | null) => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
};

export const convertToNumber = (x: string) => {
  const value = +x.replace(/\D/g, '');
  if (isNaN(value)) {
    return null;
  }
  return value;
};

export const zenkakuToHankaku = (str: string) => {
  return str.replace(/[０-９]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
}